<template>
  <div class="navbar navbar-inverse">
    <div class="navbar-header"></div>
    <div class="clearfix"></div>
    <transition name="slide">
      <div class="navbar-collapse collapse in" v-show="!collapsed">
        <ul class="nav navbar-nav">
          <li v-for="(nav,index) in getSubNav"
              :key='index'
              class="menu-item">
            <router-link :to="nav.path"
            :class="{'current':(currentRoute == '/ecology/component-list' && nav.path == '/ecology/componentManage')}"
                         active-class='current' v-if="nav.inRole">
              <span :class="[nav.style]">{{ nav.title }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  data () {
    return {
      navs: [],
      collapsed: false,
      currentRoute: null
    }
  },
  methods: {
    toggleCollapsed: function (event) {
      this.collapsed = !this.collapsed
    }
  },
  computed: {
    getSubNav () {
      let route = this.$route.path.split('/')[1]
      if (this.navs.length >= 4) {
        switch (route) {
          case 'order':
            return this.navs[0].sub
          case 'service':
            return this.navs[1].sub
          case 'ecology':
            return this.navs[2].sub
          case 'userHome':
            return this.navs[3].sub
          case 'system':
            return this.navs[4].sub
        }
      }
      return this.navs
    }
  },
  watch: {
    '$route' () {
      this.currentRoute = this.$route.path
    }
  },
  created () {
    let that = this
    this.$identity.getNav().then(res => {
      that.navs = res
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nav-menu.vue